import { ImageTile } from 'components/tiles/image-tile.js';

export type CameraImagePanelProps = {
  description: string;
  image: string;
  cantExpand?: boolean;
};

export const CameraImagePanelV1 = ({ value: { image } }: { value: CameraImagePanelProps }) => {
  if (image) {
    return <ImageTile image={image} />;
  }
  return null;
};
